export const GET_TRANSACTION = 'NOV/get_transaction';
export const APPROVE_TRANSACTION = 'NOV/approve_transaction';
export const UPDATE_TRANSACTION = 'NOV/update_transaction';
export const SHOW_TRANSACTION = 'NOV/show_transaction';
export const START_ASSESSMENT = 'NOV/start_assessment';
export const GET_SETTINGS = 'NOV/get_settings';
export const UPDATE_TEST_STATUS = 'NOV/update_health_status';
export const ASSESS_RECEIPT = 'BIRTH_CERTIFICATES/assess_receipt';
export const OR_CHECK = 'NOV/or_check';
export const OCCUPATIONAL_PERMIT_URI =
  'api/v1/administrators/occupational_permit/';
export const HEALTH_CERTIFICATE_URI =
  'api/v1/administrators/health_certificate/';

export const DEPENDENCIES = {
  health_certificate_amount: {
    label: 'Health Certificate',
  },
  occupational_permit_amount: {
    label: 'Occupational Permit',
  },
  card_type: {
    label: 'CARD TYPE',
  },
  stool_amount: {
    label: 'Stool',
  },
  sputum_amount: {
    label: 'Sputum',
  },
  drug_test_amount: {
    label: 'Drug Test',
  },
  rpr_syphilis_amount: {
    label: 'RPR Syphilis',
  },
  gram_stain: {
    label: 'Gram Stain',
  },
};

export const FORM_DATA = {
  status: 'REJECT',
  remarks: '',
};

export const NOV_EOR_URL =
  'api/v1/administrators/transaction_histories/nov/{id}/view_eor'
export const GENERATE_EOR = 
  'api/v1/administrators/transaction_histories/nov/{id}/generate_eor'
// export const GENERATE_OR = 'NOV/generate_or';